import React from 'react'
import {ServerConfig} from 'config'

import NonPaginatedList from '../../components/EntryListAndEdit/NonPaginatedList'


const Machines = () => {
  const non_editable_fields = [
    ["id", "id", ""],
    //["operationtype_id", "Operation Type", "operationtype_id"],
    ["operationtype_name", "Operation Type", ""],
      ["cert_id", "Cert-ID", ""],
    ["dc_id", "DC-ID", ""],
    ["site", "Site", ""]
  ];

  const editable_fields = [
    ["name", "Name"],
    //["state", "State"],
    //["location", "Location"],
    ["secret", "Secret"],
    //["staff_password", "Password"],
    //["cert_id", "Cert ID"],
    ["allow_cash_payout", "Allow Cash Payout", "boolean"],
  ];

  // TODO: unify endpoints for getting lists with parameters!
  // TODO: bring all pages on the same NonPaginated or Paginated List components!

  return (
    <>
      <NonPaginatedList
        list_get_url={`${ServerConfig.SERVER_URL}/tenant/machines`}
        detail_get_url={`${ServerConfig.SERVER_URL}/tenant/machines/`}
        detail_put_url={`${ServerConfig.SERVER_URL}/tenant/machines/`}

        column_names={["online", "id", "secret"]}
        header_names={["Online?", "id", "Secret"]}

        optional_column_names={["name", "site", "cert_id", "dc_id", "allow_cash_payout_str", "operationtype_name"]}
        optional_header_names={["name", "Site", "Cert ID", "DC ID", "Cash Payout?", "Operation Type"]}

        filter_inputs={[]}

        editable_fields={editable_fields}
        non_editable_fields={non_editable_fields}
        show_machine_stats={true}
      />
    </>
  )
}

export default Machines
